import { Typography, styled } from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../theme/default.theme";

const NotFound = ({ className }: IWithClassName) => (
    <div className={className}>
        <div className="not-found-container">
            <Typography variant="h5" className="not-found-title">
                The page you were looking for does not exist
            </Typography>
            <Typography variant="body1" className="not-found-description">
                You may have mistyped the address or the page may have moved.
            </Typography>
        </div>
    </div>
);

export default styled(NotFound)(({ theme }: IWithThemeProps) => ({
    ".not-found-container": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: theme?.spacing(4),
        maxWidth: "600px",
        margin: "100px auto",
        borderRadius: theme?.spacing(2.5),
        backgroundColor: theme?.palette.collapsibleFeatures.bgColor,
    },
    ".not-found-title": {
        color: theme?.palette.error.main,
        fontWeight: "bold",
        marginBottom: theme?.spacing(2),
    },
    ".not-found-description": {
        color: theme?.palette.text.secondary,
    },
}));
